import React from 'react'

export enum ButtonTypeEnum {
  button = 'button',
  submit = 'submit',
}

interface Props {
  additionalStyles?: string
  buttonText: string
  handleClick?: any
  isDisabled?: boolean
  type?: ButtonTypeEnum
}

export const SimpleButton: React.FunctionComponent<Props> = ({
  additionalStyles = '',
  buttonText,
  handleClick,
  isDisabled = false,
  type = ButtonTypeEnum.button,
}) => {
  return (
    <button
      type={type}
      disabled={isDisabled}
      onClick={handleClick}
      className={`text-sm font-medium text-center whitespace-nowrap rounded duration-300 py-2 px-4 w-fit md:ml-auto
      ${
        isDisabled ? 'bg-gray-40' : 'bg-nptDGreen text-white'
      } ${additionalStyles} `}
    >
      {buttonText}
    </button>
  )
}
